import { useState } from 'react';

import { useAppContext } from '../../shared';
import { Input, Dropdown } from '../../components';
import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import type { ContactItemType } from '../../templates';

type FormType = ContactItemType;

type ContactModalProps = {
  loading: boolean;
  initialValues?: FormType;

  onClose: () => void;
  onSumbit: (payload: FormType) => void;
};

const ContactModal: React.FC<ContactModalProps> = ({
  loading,
  initialValues,
  onClose,
  onSumbit,
}) => {
  const { meta } = useAppContext();
  const [values, setValues] = useState(initialValues);

  return (
    <Form<FormType> initialValue={values} onChange={setValues}>
      <Modal
        open
        title={initialValues ? 'Edit Contact' : 'Add Contact'}
        onClose={onClose}
        bottomActions={
          <>
            <SubmitButton
              type="primary"
              loading={loading}
              onClick={() => values && onSumbit?.(values)}
            >
              Save
            </SubmitButton>
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md">
          <FormItem<FormType> label="Email" name="email" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Phone" name="phone" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="First Name" name="first_name" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Last Name" name="last_name" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Description" name="description">
            <Input multiline rows={5} />
          </FormItem>
          <FormItem<FormType> label="Campaign" name="campaign_id">
            <Dropdown
              options={[{ value: '', label: '\u00A0' }, ...meta.campaigns]}
            />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};

export default ContactModal;
